import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Download from "../../Assets/Icon/download.webp";
import Print from "../../Assets/Icon/print.webp";
import {
  DirectorAdminEmployeeActiveList,
  DirectorEmployeeActiveList,
  DirectorHodEmployeeActiveList,
  DirectorIndentEmployeeActiveList,
  DirectorStoreInchargeEmployeeActiveList
} from "../../Repository/Api";
import { errorMsg } from "../Toastify";
const itemsPerPage = 10;

const DirectorEmployeeList = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [employeeList, setEmployeeList] = useState({});
  const [hodEmployeeList, setHodEmployeeList] = useState({});
  const [adminEmployeeList, setAdminEmployeeList] = useState({});
  const [indentEmployeeList, setIndentEmployeeList] = useState({});
  const [storeInchargeEmployeeList, setStoreInchargeEmployeeList] = useState(
    {}
  );

  useEffect(() => {
    getEmployeeList();
    getHodEmployeeList();
    getAdminEmployeeList();
    getIndentEmployeeList();
    getStoreInchargeEmployeeList();
  },[]);

  const [active, setActive] = useState(0);
  const links = ["Staff", "Hod", "Admin", "Indent", "Store Incharge"];
  const showSelected = (index) => {
    setActive(index);
  };

  const [activeEmployee, setActiveEmployee] = useState(0);
  const linksEmployee = ["Active", "Inactive", "Releaved"];
  const showSelectedEmployee = (index) => {
    setActiveEmployee(index);
  };
  const [activeHod, setActiveHod] = useState(0);
  const linksHod = ["Active", "Inactive"];
  const showSelectedHod = (index) => {
    setActiveHod(index);
  };
  const [activeIndend, setActiveIndend] = useState(0);
  const linksIndend = ["Active", "Inactive"];
  const showSelectedIndend = (index) => {
    setActiveIndend(index);
  };

  const [dummyleaveList, setdummyLeaveList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const SearchfilteredData = dummyleaveList?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchText) {
      setEmployeeList(SearchfilteredData);
      setCurrentPage(1)
    } else {
      setEmployeeList(dummyleaveList);
    }
  }, [searchText, dummyleaveList]);
  const getEmployeeList = async () => {
    const response = await DirectorEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setEmployeeList(response?.data?.employee_details);
      setdummyLeaveList(
        response?.data?.employee_details
      );

    } else {
      errorMsg(response.message);
    }
  };
  //HOD
  const [dummyleaveListhod, setdummyLeaveListHod] = useState([]);

  const [searchTextHod, setSearchTextHod] = useState("");

  const SearchfilteredDataHod = dummyleaveListhod?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextHod.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextHod) {
      setHodEmployeeList(SearchfilteredDataHod);
      setCurrentPage(1)
    } else {
      setHodEmployeeList(dummyleaveListhod);
    }
  }, [searchTextHod, dummyleaveListhod]);
  const getHodEmployeeList = async () => {
    const response = await DirectorHodEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setHodEmployeeList(response?.data?.employee_details);
      setdummyLeaveListHod(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  //Admin

  const [dummyleaveListAdmin, setdummyLeaveListAdmin] = useState([]);

  const [searchTextAdmin, setSearchTextAdmin] = useState("");

  const SearchfilteredDataAdmin = dummyleaveListAdmin?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextAdmin.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextAdmin) {
      setAdminEmployeeList(SearchfilteredDataAdmin);
      setCurrentPage(1)
    } else {
      setAdminEmployeeList(dummyleaveListAdmin);
      
    }
  }, [searchTextAdmin, dummyleaveListAdmin]);

  const getAdminEmployeeList = async () => {
    const response = await DirectorAdminEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setAdminEmployeeList(response?.data?.employee_details);
      setdummyLeaveListAdmin(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  //Indend

  const [dummyleaveListIndend, setdummyLeaveListIndend] = useState([]);

  const [searchTextIndend, setSearchTextIndend] = useState("");

  const SearchfilteredDataIndend = dummyleaveListIndend?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextIndend.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextIndend) {
      setIndentEmployeeList(SearchfilteredDataIndend);
      setCurrentPage(1)
    } else {
      setIndentEmployeeList(dummyleaveListIndend);
    }
  }, [searchTextIndend, dummyleaveListIndend]);
  const getIndentEmployeeList = async () => {
    const response = await DirectorIndentEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setIndentEmployeeList(response?.data?.employee_details);
      setdummyLeaveListIndend(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };

  //store incharge

  const [dummyleaveListStoreIncharge, setdummyLeaveListStoreIncharge] = useState([]);

  const [searchTextStoreIncharge, setSearchTextStoreIncharge] = useState("");

  const SearchfilteredDataStoreIncharge = dummyleaveListStoreIncharge?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextStoreIncharge.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextStoreIncharge) {
      setStoreInchargeEmployeeList(SearchfilteredDataStoreIncharge);
      setCurrentPage(1)
    } else {
      setStoreInchargeEmployeeList(dummyleaveListStoreIncharge);
    }
  }, [searchTextStoreIncharge, dummyleaveListStoreIncharge]);
  const getStoreInchargeEmployeeList = async () => {
    const response = await DirectorStoreInchargeEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setStoreInchargeEmployeeList(response?.data?.employee_details);
      setdummyLeaveListStoreIncharge(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const employeeListArray = Array.isArray(employeeList) ? employeeList : [];
  const employeeIndentListArray = Array.isArray(indentEmployeeList)
    ? indentEmployeeList
    : [];
  const employeeHodListArray = Array.isArray(hodEmployeeList)
    ? hodEmployeeList
    : [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employeeListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const currentItemsHod = employeeHodListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const currentItemsIndent = employeeIndentListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const activeLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "active").length
    : 0;
  const inactiveLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "inactive").length
    : 0;
  const releavedLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "releaved").length
    : 0;
  const activeHodLength = Array.isArray(currentItemsHod)
    ? currentItemsHod.filter((item) => item.status === "active").length
    : 0;
  const inactiveHodLength = Array.isArray(currentItemsHod)
    ? currentItemsHod.filter((item) => item.status === "inactive").length
    : 0;
  const activeIndentLength = Array.isArray(currentItemsIndent)
    ? currentItemsIndent.filter((item) => item.status === "active").length
    : 0;
  const inactiveIndentLength = Array.isArray(currentItemsIndent)
    ? currentItemsIndent.filter((item) => item.status === "inactive").length
    : 0;

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="labeltitle">Employee List</h6>
                  </div>
                  <div className="col-lg-6">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="col-lg-3 p-0 my-auto">
                    <div className="tablealign">
                      <img className="tableicon" src={Download} alt="Dasb" />
                      <img className="tableicon" src={Print} alt="Dasb" />
                    </div>
                  </div>
                </div>
                <div className="scroll-table">
                  {active === 0 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <ul className="searchtopflex">
                          {linksEmployee.map((linkEmp, index) => {
                            return (
                              <li
                                onClick={() => showSelectedEmployee(index)}
                                key={linkEmp}
                                className={
                                  activeEmployee === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linkEmp}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {activeEmployee === 0 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td className="textformat">
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td className="textformat">
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <td></td>
                            <td colSpan="4">
                              <div className="mt-5">
                                {Array.from({
                                  length: Math.ceil(
                                    employeeList.length / itemsPerPage
                                  ),
                                }).map((page, index) => (
                                  <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className="paginationbutton"
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                              </div>
                            </td>
                          </tfoot>
                        </table>
                      )}
                      {activeEmployee === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                      {activeEmployee === 2 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {releavedLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "releaved")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 1 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextHod}
                              onChange={(e) => setSearchTextHod(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-5">
                        <ul className="searchtopflex">
                          {linksHod.map((linksHo, index) => {
                            return (
                              <li
                                onClick={() => showSelectedHod(index)}
                                key={linksHo}
                                className={
                                  activeHod === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linksHo}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {activeHod === 0 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeHodLength > 0 ? (
                              currentItemsHod &&
                              currentItemsHod
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td className="textformat">
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <td></td>
                            <td colSpan="4">
                              <div className="mt-5">
                                {Array.from({
                                  length: Math.ceil(
                                    hodEmployeeList.length / itemsPerPage
                                  ),
                                }).map((page, index) => (
                                  <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className="paginationbutton"
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                              </div>
                            </td>
                          </tfoot>
                        </table>
                      )}
                      {activeHod === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveHodLength > 0 ? (
                              currentItemsHod &&
                              currentItemsHod
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 2 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextAdmin}
                              onChange={(e) =>
                                setSearchTextAdmin(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                          </tr>
                        </thead>
                        <tbody>
                          {adminEmployeeList?.length > 0 ? (
                            adminEmployeeList &&
                            adminEmployeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td>
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id ? employee?.email_id : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>

                                <td className="viewoption">
                                  <Link
                                    to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table></>

                  )}
                  {active === 3 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextIndend}
                              onChange={(e) =>
                                setSearchTextIndend(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-5">
                        <ul className="searchtopflex">
                          {linksIndend.map((linksInd, index) => {
                            return (
                              <li
                                onClick={() => showSelectedIndend(index)}
                                key={linksInd}
                                className={
                                  activeIndend === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linksInd}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {activeIndend === 0 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Indent ID</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeIndentLength > 0 ? (
                              currentItemsIndent &&
                              currentItemsIndent
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <td></td>
                            <td colSpan="4">
                              <div className="mt-5">
                                {Array.from({
                                  length: Math.ceil(
                                    indentEmployeeList.length / itemsPerPage
                                  ),
                                }).map((page, index) => (
                                  <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className="paginationbutton"
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                              </div>
                            </td>
                          </tfoot>
                        </table>
                      )}
                      {activeIndend === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveIndentLength > 0 ? (
                              currentItemsIndent &&
                              currentItemsIndent
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td>
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 4 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextStoreIncharge}
                              onChange={(e) =>
                                setSearchTextStoreIncharge(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                          </tr>
                        </thead>
                        <tbody>
                          {storeInchargeEmployeeList?.length > 0 ? (
                            storeInchargeEmployeeList &&
                            storeInchargeEmployeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td>
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id ? employee?.email_id : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>

                                <td className="viewoption">
                                  <Link
                                    to={`/app/Director/DirectorEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table></>

                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorEmployeeList;
